import React, {Component} from 'react';
import axios from 'axios';
import moment from 'moment';
import { authService } from '../../services/authService';

import {
  Row,
  Col,
  Button,
  Table,
  Space,
  Tag,
  Card,
  Descriptions,
  Divider,
  Select,
  List,
  Grid,
  Input,
} from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { API_BASE_URL } from '../../config/api';

const { useBreakpoint } = Grid;

const STATUS_COLORS = {
  'Ordered': 'blue',
  'Shipped': 'orange',
  'Delivered': 'green',
  'Cancelled': 'red',
};

const STATUS_OPTIONS = [
  { label: 'Ordered', value: 'Ordered' },
  { label: 'Shipped', value: 'Shipped' },
];

class SupplyOrders extends Component {
  constructor(props){
    super(props);
    this.state = {
      loading: true,
      items: [],
      search: '',

      id: null,
      item: null,
      itemLoading: false,
    }
  }

  componentDidMount = () => {
    this.loadData()
  }

  loadData = async() => {
    const token = await authService.ensureValidToken();
    if (!token) {
      console.error('Not authenticated');
      return;
    }

    this.setState({
      loading: true,
      items: []
    })

    const params = {};
    params.clientCode = this.props.client.ClientCode;
    params.status = '';

    axios({
      method: 'GET',
      url: `${API_BASE_URL}/admin/supply-orders`,
      params,
      headers: { Authorization: `Bearer ${token}` },
    }).then(res => {
      console.log(res.data)
      this.setState({
        items: res.data.data,
        loading: false
      })
    }).catch(err => {
      console.log(err);
      this.setState({ loading: false });
    });
  }

  loadItem = async (id) => {
    const token = await authService.ensureValidToken();
    if (!token) {
      console.error('Not authenticated');
      return;
    }

    this.setState({ id, itemLoading: true, item: null, editing: false });

    axios({
      method: 'GET',
      url: `${API_BASE_URL}/admin/supply-orders/${id}`,
      headers: { Authorization: `Bearer ${token}` },
    }).then(res => {
      console.log(res)
      this.setState({
        item: res.data.data,
        itemLoading: false,
      });
    }).catch(err => {
      console.log(err);
      this.setState({ itemLoading: false });
    });
  }

  clearItem = () => {
    this.setState({ id: null, item: null, itemLoading: false, editing: false });
  }

  getFilteredItems = () => {
    const q = (this.state.search || '').trim().toLowerCase();
    if (!q) return this.state.items;
    return this.state.items.filter((record) => {
      const c = record.client || {};
      const line1 = [c.Address, c.Address2].filter(Boolean).join(' ');
      const address = [line1, c.City, `${c.State || ''} ${c.Zip || ''}`.trim()]
        .filter(Boolean).join(', ');
      const haystack = [
        record.orderNumber,
        record.clientCode,
        c.ClientCode,
        c.ClientName,
        address,
      ].filter(Boolean).join(' ').toLowerCase();
      return haystack.includes(q);
    });
  }

  renderDetail = () => {
    if (!this.state.item || !this.state.item.id) return null;
    const item = this.state.item;
    return (
      <Card
        title={item.orderNumber}
        extra={
          this.state.editing ? (
            <Select
              size="small"
              value={this.state.editStatus}
              options={STATUS_OPTIONS}
              onChange={(val) => this.setState({ editStatus: val })}
              style={{ width: 120 }}
            />
          ) : (
            <Space>
              <Tag color={STATUS_COLORS[item.status] || 'default'}>
                {item.status}
              </Tag>
            </Space>
          )
        }
      >
        <Descriptions size="small" column={1} bordered>
          <Descriptions.Item label="Order Date">
            {item.date ? moment(item.date).format('MM/DD/YYYY') : ''}
          </Descriptions.Item>
          <Descriptions.Item label="Name">
            ({item.client.ClientCode}) {item.client.ClientName}
          </Descriptions.Item>
          <Descriptions.Item label="Address">
            {[
              [item.client.Address, item.client.Address2]
                .filter(Boolean).join(' '),
              item.client.City,
              `${item.client.State || ''} ${item.client.Zip || ''}`.trim()
            ].filter(Boolean).join(', ')}
          </Descriptions.Item>
          <Descriptions.Item label="Shipping Date">
            {item.dateShipped ? moment(item.dateShipped).format('MM/DD/YYYY') : ''}
          </Descriptions.Item>
          <Descriptions.Item label="Delivery Date">
            {item.dateDelivered ? moment(item.dateShipped).format('MM/DD/YYYY') : ''}
          </Descriptions.Item>
        </Descriptions>
        <Divider orientation="left">Items</Divider>
        <Table
          size="small"
          pagination={false}
          rowKey="id"
          dataSource={item.items || []}
          columns={[
            { title: 'Name', dataIndex: 'name', key: 'name' },
            {
              title: 'Qty',
              dataIndex: 'qnt',
              key: 'qnt',
              width: 60,
              align: 'right'
            },
          ]}
        />
        {item.comment && (
          <>
            <Divider orientation="left">Comment</Divider>
            <div style={{
              background: '#fafafa',
              padding: 12,
              borderRadius: 4,
              fontSize: 13,
              whiteSpace: 'pre-wrap'
            }}>
              {item.comment}
            </div>
          </>
        )}
      </Card>
    );
  }

  renderMobile = () => {
    const showDetail = !!(this.state.item && this.state.item.id);

    if (showDetail) {
      return (
        <Row gutter={[0, 12]}>
          <Col span={24}>
            <Button
              icon={<ArrowLeftOutlined />}
              onClick={this.clearItem}
              size="small"
            >
              Back to orders
            </Button>
          </Col>
          <Col span={24}>
            {this.renderDetail()}
          </Col>
        </Row>
      );
    }

    return (
      <Card styles={{ body: { padding: 8 } }}>
        <Input.Search
          allowClear
          placeholder="Search orders"
          value={this.state.search}
          onChange={(e) => this.setState({ search: e.target.value })}
          style={{ marginBottom: 8 }}
        />
        <List
          loading={this.state.loading}
          dataSource={this.getFilteredItems()}
          rowKey="id"
          pagination={{ pageSize: 15, size: 'small', align: 'center' }}
          renderItem={(record) => {
            const c = record.client || {};
            const line1 = [c.Address, c.Address2].filter(Boolean).join(' ');
            const address = [line1, c.City, `${c.State || ''} ${c.Zip || ''}`.trim()]
              .filter(Boolean).join(', ');
            return (
              <List.Item
                onClick={() => this.loadItem(record.id)}
                style={{ cursor: 'pointer', padding: '12px 8px' }}
              >
                <div style={{ width: '100%' }}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 4,
                  }}>
                    <strong style={{ fontSize: 14 }}>{record.orderNumber}</strong>
                    {record.status && (
                      <Tag color={STATUS_COLORS[record.status] || 'default'} style={{ marginRight: 0 }}>
                        {record.status}
                      </Tag>
                    )}
                  </div>
                  <div style={{ fontSize: 13 }}>
                    {c.ClientName || ''} {c.ClientCode ? `(${c.ClientCode})` : ''}
                  </div>
                  {address && (
                    <div style={{ fontSize: 12, color: '#888' }}>
                      {address}
                    </div>
                  )}
                  <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
                    {record.date ? new Date(record.date).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    }) : ''}
                  </div>
                </div>
              </List.Item>
            );
          }}
        />
      </Card>
    );
  }

  render(){
    const { screens } = this.props;
    const isMobile = screens && !screens.md;

    if (isMobile) {
      return this.renderMobile();
    }

    const columns = [
      { title: 'Order Number', dataIndex: 'orderNumber', key: 'orderNumber' },
      { title: 'Client ID', dataIndex: 'clientCode', key: 'clientCode' },
      {
        title: 'Client Name',
        key: 'name',
        render: (_, record) => record.client?.ClientName || '',
      },
      {
        title: 'Address',
        key: 'address',
        render: (_, record) => {
          const c = record.client;
          if (!c) return '';
          const line1 = [c.Address, c.Address2].filter(Boolean).join(' ');
          return `${line1}, ${c.City}, ${c.State} ${c.Zip}`;
        },
      },
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        render: (value) => value ? new Date(value).toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }) : '',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (value) => value ? <Tag color={STATUS_COLORS[value] || 'default'}>{value}</Tag> : null,
      },
    ];

    return(
      <Row>
        <Col span={16}>
          <Row>
            <Col span={24}>
              <Card>
                <Input.Search
                  allowClear
                  placeholder="Search orders"
                  value={this.state.search}
                  onChange={(e) => this.setState({ search: e.target.value })}
                  style={{ marginBottom: 12, maxWidth: 320 }}
                />
                <Table
                  columns={columns}
                  dataSource={this.getFilteredItems()}
                  rowKey="id"
                  size='small'
                  loading={this.state.loading}
                  pagination={{ pageSize: 15 }}
                  onRow={(record) => ({
                    onClick: () => this.loadItem(record.id),
                    style: {
                      cursor: 'pointer',
                      background: this.state.id === record.id ? '#c3e2fa' : undefined,
                    },
                  })}
                />
              </Card>
            </Col>
          </Row>
        </Col>
        <Col span={8}>
          {this.renderDetail()}
        </Col>
      </Row>
    )
  }
}

export default function SupplyOrdersWrapper(props) {
  const screens = useBreakpoint();
  return <SupplyOrders {...props} screens={screens} />;
}
